// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__vAayi","file":"styles_file__3FsSc"};